import React, { useState, useRef, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { patchRequest } from "../../../../components/axiosClient";
import { useNavigate } from "react-router-dom";
import { MANAGE_PROJECT_TASK_STATUS_INDEX } from "../../../../components/utils";
import { GoGrabber } from "react-icons/go";

const DragPopup = ({
  columnTitles,
  getTaskList,
  projectId,
  setIsOpen,
  isOpen,
  handleTitleIndexChange,
}) => {
  // const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const [names, setNames] = useState(columnTitles || []);

  const dropdownRef = useRef(null);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedNames = Array.from(names);
    const [movedItem] = updatedNames.splice(result.source.index, 1);
    updatedNames.splice(result.destination.index, 0, movedItem);

    setNames(updatedNames);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative inline-block">
      {/* Dropdown Button */}

      {/* Dropdown List */}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[51]">
          <div
            ref={dropdownRef}
            className="bg-white p-4 rounded-md shadow-lg w-full max-w-md"
          >
            <div className=" p-1 text-start font-medium w-full">
              Change Index of Status
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="namesList">
                {(provided) => (
                  <ul
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="max-h-96 overflow-auto w-full"
                  >
                    {names.map((name, index) => (
                      <Draggable
                        key={name.id.toString()}
                        draggableId={name.id.toString()}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <li
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                            className={`${
                              snapshot?.isDragging
                                ? "shadow-lg bg-gray-100 "
                                : ""
                            }  p-2 hover:bg-gray-100 cursor-pointer border-b border-[#EFEFEF] flex justify-start items-center text-nowrap w-full`}
                          >
                            <div
                              className="drag-handle cursor-grab mr-1"
                              {...provided.dragHandleProps} // Drag handle only here
                            >
                              <GoGrabber />
                            </div>
                            {name.title}
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
            <div className="mt-4 flex justify-end space-x-4">
              <button
                onClick={() => setIsOpen(false)}
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
              >
                Close
              </button>
              <button
                onClick={() => handleTitleIndexChange(names)}
                className="border-0 text-white rounded-md py-2.5 px-3.5 font-medium bg-[#267072]"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DragPopup;
